module.exports = __webpack_public_path__ + "img/019.7eab274b.png";